/**
 * 学会全景
 */

import Container from '@/containers';

const ybjRouter = {
    path: '/ybj',
    name: 'ybj',
    component: Container,
    redirect: '/ybj/glxh',
    children: [
        {
            path: 'glxh',
            name: 'glxh',
            component: () => import('@/views/ybj/glxh/index'),
            meta: {
                title: '中国公路学会',
                subTitle:'学会全景',
                returnLink:'/xhqj'
            }
        },
        {
            path: 'hxh',
            name: 'hxh',
            component: () => import('@/views/ybj/hxh/index'),
            meta: {
                title: '中国化学会',
                subTitle:'学会全景',
                returnLink:'/xhqj'
            }
        },
        {
            path: 'jxgc',
            name: 'jxgc',
            component: () => import('@/views/ybj/jxgc/index'),
            meta: {
                title: '中国机械工程学会',
                subTitle:'学会全景',
                returnLink:'/xhqj'
            }
        },
        {
            path: 'qcxh',
            name: 'qcxh',
            component: () => import('@/views/ybj/qcxh/index'),
            meta: {
                title: '中国汽车工程学会',
                subTitle:'学会全景',
                returnLink:'/xhqj'
            }
        },
        {
            path: 'djgc',
            name: 'djgc',
            component: () => import('@/views/ybj/djgc/index'),
            meta: {
                title: '中国电机工程学会',
                subTitle:'学会全景',
                returnLink:'/xhqj'
            }
        }
    ]
};

export default ybjRouter;